import horizontal from '../../assets/brand/crow-logo-horizontal.svg';
import stacked from '../../assets/brand/crow-logo-stacked.svg';
import mark from '../../assets/brand/crow-mark.svg';

const SRC = { horizontal, stacked, mark };
const HEIGHT = { horizontal: 28, stacked: 72, mark: 32 };

// The brand mark. alt="CROW" replaces the visible text it stands in for, so
// screen readers hear the name once. Generated from brand/ -- see brand/sync.mjs.
export default function CrowLogo({ variant = 'horizontal', className = '', height }) {
  return (
    <img
      src={SRC[variant]}
      alt="CROW"
      height={height || HEIGHT[variant]}
      className={`block w-auto ${className}`}
      style={{ height: height || HEIGHT[variant] }}
    />
  );
}
